import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges, TemplateRef } from '@angular/core';
import { WIDGET_DATA } from 'src/app/components/suggestions/suggestions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';
import { countProvider } from 'src/app/components/suggestions/suggestions.component';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { FormValidation } from 'src/app/services/FormValidation';
import { JobService } from 'src/app/services/job.service';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { CandidateCardComponent } from 'src/app/components/cards/candidate-card/candidate-card.component';
import { CandidateJobDetailsComponent } from 'src/app/components/candidate-job-details/candidate-job-details.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

declare var $: any
@Component({
  selector: 'app-resume-request',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonSkeletonComponent,
CandidateCardComponent,
    CandidateJobDetailsComponent,
    InfiniteScrollModule
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './resume-request.component.html',
  styleUrls: ['./resume-request.component.scss']
})
export class ResumeRequestComponent extends FormValidation implements OnInit, OnChanges {

  @Input('title') title: string = 'Resume Request';
  @Input() widgetDesc: string;
  @Input() suggestion: any;
  userType = localStorage.getItem('userType');
  headerTitle: string = 'Resume Request';
  user: any = [{ a: 1 }, { a: 2 }, { a: 3 }, { a: 4 }];
  response = new BehaviorSubject<any[]>([]);
  stopScroll : boolean = false;
  prevAfterKey : string = '';
  loadAPIcall:boolean=false;
  filterjob;
  some : boolean = false;
  totalCount: any;
  @Input() inputData: string;
  @Input() page: any;
  configlist = {
    itemsPerPage: 5,
    currentPage: 1
  }
  url = AppSettings.photoUrl;
  pathdata: any;
  userId = localStorage.getItem('userId')
  @Input() maxMin: any = {};
  viewType: string = "MIN";
  obj: any = {
    limit: 10,
    searchAfterKey: null,
    userId: localStorage.getItem('userId')
  }

  candidateId: any;
  jobId: any;
  searchConfig: any = { pageNumber: 0 }
  FormData: any;
  resumeupload;
  fileDragdrop: any;
  viewedList: any = [];
  object: any;
  modalRef: BsModalRef;
  resumeuploaduserId: any;
  fileSize = AppSettings.FILE_SIZE;
  tempFile: File;
  loaddata:boolean=false

  constructor(private a_route: ActivatedRoute,  private JobServicecolor:JobService,private modalService: BsModalService, private router: Router,
    private provider:countProvider, private apiService: ApiService, private util: UtilService,
    @Optional() @Inject(WIDGET_DATA) private widgetData: any) {
      super();
      // Apply injected widget data (Angular 15 NgComponentOutlet pattern)
      if (this.widgetData) {
        if (this.widgetData.maxMin) {
          this.maxMin = this.widgetData.maxMin;
          if (this.widgetData.maxMin.viewType) {
            this.viewType = this.widgetData.maxMin.viewType;
          }
        }
        if (this.widgetData.widgetDesc) {
          this.headerTitle = this.widgetData.widgetDesc;
        }
        if (this.widgetData.inputData) {
          this.inputData = this.widgetData.inputData;
        }
        if (this.widgetData.page) {
          this.page = this.widgetData.page;
        }
      }
     }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle maxMin changes - critical for showing MAX view on suggestions page
    if (changes.maxMin) {
      const newMaxMin = changes.maxMin.currentValue;
      if (newMaxMin) {
        this.maxMin = newMaxMin;
        if (newMaxMin.viewType) {
          this.viewType = newMaxMin.viewType;
        }
      }
    }
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    if (this.maxMin && this.maxMin.viewType) {
      this.viewType = this.maxMin.viewType;
    }
    this.userType = localStorage.getItem('userType');
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }
    this.a_route.queryParams.subscribe((res) => {
      this.filterjob = res.candidatefilter;
      if (res.master != "NETWORK" && res.master != "TEAM" && res.menu != null && res.menu != undefined) {
        this.headerTitle = res.menu;
      }
    })

    this.object = null;


    this.jobsApi();

  }

  getInitialstwo(firstname: string,lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname,lastname);
  }

  getColortwo(firstname: string,lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname,lastname);
  }

  jobsApi() {
    if(this.stopScroll){
      return;
    }
    this.loadAPIcall=true
    this.apiService.create("candidates/findMyCandidatesResumeRequests", this.obj).subscribe((res) => {
      this.loaddata=true
      this.loadAPIcall=false
      this.util.stopLoader();
      if (res.data != null && res.data.resumeRequests) {
        const afterKey = res.data.searchAfterKey;
        const resData = res.data.resumeRequests;

        if(this.prevAfterKey === afterKey || resData.length  === 0){
          this.stopScroll = true;
          this.util.stopLoader();
          return;
        }

        if(res.data.totalCount!=undefined){
          this.totalCount = res.data.totalCount;
          this.provider.setCount(this.totalCount , "ResumeRequestComponent");
        }

        const data = resData.map(ele => {
          // Check if candidateEntity exists (wrapper structure)
          if (ele.candidateEntity && ele.user) {
            // ALWAYS use root level user (candidate owner) for photo in resume-request scenario
            ele.candidateEntity.user = ele.user;

            // Format photo URL in candidateEntity.user
            if (ele.candidateEntity.user.photo) {
              ele.candidateEntity.user.photo = AppSettings.photoUrl + ele.candidateEntity.user.photo;
            } else {
              ele.candidateEntity.user.photo = null;
            }
          }

          // Return whole wrapper object
          return ele;
        });

        const combined = [...this.response.getValue() , ...data];
        this.response.next(combined);
        this.prevAfterKey = afterKey;
      }else{
        this.loaddata=false
      }

    })
  }

  modelopen(data) {
    let dataPass: any = {};
    dataPass.data = data;
    dataPass.menu = this.headerTitle || this.widgetDesc || 'Resume Request';
    dataPass.master = this.page;
    dataPass.masterMenu = this.inputData;
    dataPass.widgetName = "ResumeRequestComponent";
    dataPass.count = this.totalCount;
    this.router.navigate(['suggestions'], { queryParams: dataPass })
  }

  pagecount(event) {
    this.configlist.currentPage = event;
    this.page = event;
    this.obj.pageNumber = this.page - 1;
    this.jobsApi();

  }

  removeFiles() {
    $("#fileDropRef")[0].value = '';
    if (this.fileDragdrop != null && this.resumeupload != null) {
      this.fileDragdrop = null
      this.resumeupload = null
    }

  }
  onFileDropped($event) {
    // $event from drag and drop is usually an array of files
    if ($event && $event.length > 0) {
      this.prepareFilesList($event); // Pass the array directly
    }
  }

  onDownload() {
    const file: File = this.tempFile;
    this.downloadFile(new Blob([file]), file.name);
  }

  downloadFile(blob: Blob, fileName: string): void {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 0);
  }

  fileBrowseHandler(files) {
    if (files && files.length > 0) {
      this.tempFile = files[0];
      this.prepareFilesList(files);
    }
  }



  // prepareFilesList(files: File) {
  //   // this.resumeupload = undefined;
  //   this.fileDragdrop = files[0];
  //   this.resumeupload = files[0];
  //   var fromate = ['application/pdf', 'application/docx', 'application/doc', 'text/plain', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword']
  //   if (files[0].size > this.fileSize) {
  //     this.fileDragdrop = null;
  //     Swal.fire({
  //       icon: "info",
  //       title: "Please upload file lesser than 10 MB",
  //       showDenyButton: false,
  //       timer: 3000,
  //     })
  //     $("#fileDropRef")[0].value = '';
  //     this.resumeupload = null
  //   }
  //   else if (fromate.includes(files[0].type)) {
  //     this.fileDragdrop = files[0];
  //     this.resumeupload = files[0];

  //   } else {
  //     this.fileDragdrop = "";
  //     this.resumeupload = undefined;
  //     Swal.fire({
  //       icon: "info",
  //       title: "Please upload a valid format.",
  //       showDenyButton: false,
  //       timer: 3000,
  //     })
  //   }
  // }

     prepareFilesList(files: Array<File> | FileList) {
        // Ensure we have a valid file
        if (!files || files.length === 0) {
          return;
        }
    
        const file = files[0]; // Get the first file
    
        // Check file size
        if (file.size > this.fileSize) {
          Swal.fire("", `${this.IMAGE_ERROR}`, "info");
          $("#fileDropRef")[0].value = '';
          return;
        }
    
        // Define acceptable formats
        const acceptableFormats = [
          'application/pdf',
          'application/docx',
          'application/doc',
          'text/plain',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/msword'
        ];
    
        // Check if file type is acceptable
        if (acceptableFormats.includes(file.type)) {
          // Create a more robust file object with properties your template can display
          this.fileDragdrop = {
            file: file,
            fileName: file.name,
            fileSize: this.formatBytes(file.size),
            fileType: file.type
          };
          this.resumeupload = file;
        } else {
          this.fileDragdrop = null;
          this.resumeupload = null;
          Swal.fire({
            icon: "info",
            title: "Please upload a valid format.",
            showDenyButton: false,
            timer: 3000,
          });
        }
      }
  
    // Helper function to format bytes
    formatBytes(bytes: number, decimals: number = 2): string {
      if (bytes === 0) return '0 Bytes';
  
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  
      const i = Math.floor(Math.log(bytes) / Math.log(k));
  
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }


  open(data, path) {

  }

  model(items, template: TemplateRef<any>, index) {
    this.util.startLoader();
    this.object = null;
    this.resumeupload = undefined;
    this.object = index;
    this.fileDragdrop = null;
    this.resumeuploaduserId = items.user.userId;
    this.candidateId = items.candidateEntity.candidateId;
    if (items.jobDetails != null) {
      this.jobId = items.jobDetails.jobId;
    }
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    let resume: Array<any> = items.candidateEntity.resumes
    if (resume == null || undefined) {
      this.util.stopLoader();
      this.modalRef = this.modalService.show(template, ngbModalOptions);
      this.util.stopLoader();
    }
    // else if (resume.length >= 3) {
    //   this.util.stopLoader();
    //   Swal.fire(
    //     "You Already have 3 resumes , please delete and add another resume"
    //   )
    // }
  }

  onScrollDown(){
    if(!this.stopScroll&&this.obj.searchAfterKey != this.prevAfterKey){
      this.obj.searchAfterKey = this.prevAfterKey;
      this.jobsApi();
    }
  }


}
